var React = require('react');

function Cog (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#5B00DB","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M15.3 12c0 1.841-1.477 3.333-3.299 3.333-1.822 0-3.298-1.492-3.298-3.333 0-1.841 1.476-3.333 3.298-3.333S15.3 10.159 15.3 12z","key":0}),React.createElement("path",{"d":"m22 14.69-2.234-1.302A7.96 7.96 0 0 0 19.89 12a7.99 7.99 0 0 0-.148-1.503l2.036-1.188L19.14 4.69l-2.066 1.206a7.903 7.903 0 0 0-2.461-1.431V2H9.334v2.465c-.9.322-1.722.806-2.44 1.412L4.86 4.69 2.22 9.309l1.987 1.16A7.912 7.912 0 0 0 4.056 12c0 .484.047.955.129 1.417L2 14.69l2.639 4.619 2.164-1.262a7.9 7.9 0 0 0 2.531 1.488V22h5.278v-2.465a7.977 7.977 0 0 0 2.554-1.506l2.195 1.28L22 14.69z","key":1})]));
}

Cog.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Cog;

Cog.default = Cog;
